import { useState } from 'react';
import RelationsLoginForm from 'src/containers/crecer/seminaries/relations/RelationsLoginForm';
import RelationsQuestions from 'src/containers/crecer/seminaries/relations/RelationsQuestions';
import RelationsInitialForm from 'src/containers/crecer/seminaries/relations/RelationsInitialForm';
import styled from '@emotion/styled';
import RelationsMessage from 'src/containers/crecer/seminaries/relations/RelationsMessage';
import { fetchRelationInscription } from 'src/containers/crecer/seminaries/relations/relationInscription';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';
import Swal from 'sweetalert2';

const RelationsFormSteps = styled.div``;

const RelationsForm = () => {
  const [step, setStep] = useState('welcome');
  const [inputs, setInputs] = useState({ identification: '', phone: '', waitlist: false });
  const getCaptchaToken = useRecaptchaToken('relations_login');

  const checkRelationGuest = async ({
    identification = inputs.identification,
    phone = inputs.phone,
  } = {}) => {
    const captchaRequired = isCaptchaRequired();
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return null;
    }

    try {
      const response = await fetchRelationInscription({
        inputs,
        identification,
        phone,
        captcha,
        captchaRequired,
      });
      setInputs((prev) => ({
        ...prev,
        ...(response.data?.guest || {}),
        identification,
        phone,
        waitlist: !!response.data?.waitlist,
      }));
      return response.data;
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text:
          error.response?.data?.message ||
          'Ocurrió un error al verificar, por favor intenta nuevamente.',
        icon: 'error',
      });
      return null;
    }
  };

  const sentHeader = inputs.waitlist ? '¡Gracias por tu interés!' : '¡Ya estas inscrito!';
  const sentMessage = inputs.waitlist
    ? 'Daremos prioridad a las personas que aún no han realizado este seminario. Si quedan espacios disponibles, nos pondremos en contacto contigo para confirmar tu participación.'
    : 'Te esperamos.';

  return (
    <RelationsFormSteps>
      {step === 'welcome' && (
        <RelationsLoginForm
          setStep={setStep}
          inputs={inputs}
          setInputs={setInputs}
          checkRelationGuest={checkRelationGuest}
        />
      )}
      {step === 'initial' && (
        <RelationsInitialForm
          setStep={setStep}
          inputs={inputs}
          setInputs={setInputs}
          onGuestUpdated={checkRelationGuest}
        />
      )}
      {step === 'form' && (
        <RelationsQuestions setStep={setStep} inputs={inputs} setInputs={setInputs} />
      )}
      {step === 'sent' && (
        <RelationsMessage header={sentHeader} message={sentMessage} setStep={setStep} />
      )}
    </RelationsFormSteps>
  );
};

export default RelationsForm;
